export const mockCourses = [
  {
    id: 'course-1',
    title: 'Grid-Scale Battery Storage 101',
    summary: 'Fundamentals of BESS technology, use cases and economics.',
    level: 'FOUNDATIONAL',
    durationMins: 270,
    thumbnailVariant: 'v1',
    status: 'PUBLISHED',
    modules: [
      { id: 'mod-1-1', title: 'Introduction to Battery Storage', lessons: 4 },
      { id: 'mod-1-2', title: 'Use Cases & Applications', lessons: 5 },
      { id: 'mod-1-3', title: 'Technology Overview', lessons: 4 },
      { id: 'mod-1-4', title: 'Economics & Business Models', lessons: 5 },
      { id: 'mod-1-5', title: 'Project Development Basics', lessons: 4 },
      { id: 'mod-1-6', title: 'Final Assessment', lessons: 1 }
    ]
  },
  {
    id: 'course-2',
    title: 'Utility Digitisation Pathways',
    summary: 'SCADA, ADMS and the data backbone of a modern utility.',
    level: 'INTERMEDIATE',
    durationMins: 360,
    thumbnailVariant: 'v2',
    status: 'PUBLISHED',
    modules: [
      { id: 'mod-2-1', title: 'Digital Utility Transformation', lessons: 3 },
      { id: 'mod-2-2', title: 'SCADA Systems', lessons: 6 },
      { id: 'mod-2-3', title: 'Advanced Distribution Management', lessons: 5 },
      { id: 'mod-2-4', title: 'Data Architecture & Integration', lessons: 4 },
      { id: 'mod-2-5', title: 'Cybersecurity Fundamentals', lessons: 4 },
      { id: 'mod-2-6', title: 'Implementation Planning', lessons: 5 },
      { id: 'mod-2-7', title: 'Case Studies', lessons: 3 },
      { id: 'mod-2-8', title: 'Final Project', lessons: 1 }
    ]
  },
  {
    id: 'course-3',
    title: 'Storage Procurement & Tendering',
    summary: 'Run a competitive, bankable BESS procurement end-to-end.',
    level: 'ADVANCED',
    durationMins: 210,
    thumbnailVariant: 'v3',
    status: 'PUBLISHED',
    modules: [
      { id: 'mod-3-1', title: 'Procurement Strategy', lessons: 4 },
      { id: 'mod-3-2', title: 'Technical Specification', lessons: 5 },
      { id: 'mod-3-3', title: 'Commercial & Legal Terms', lessons: 4 },
      { id: 'mod-3-4', title: 'Evaluation Framework', lessons: 3 },
      { id: 'mod-3-5', title: 'Capstone: Draft RFP', lessons: 1 }
    ]
  },
  {
    id: 'course-4',
    title: 'Mini-grid Development Fundamentals',
    summary: 'From site selection to commissioning for off-grid solar-storage systems.',
    level: 'FOUNDATIONAL',
    durationMins: 300,
    thumbnailVariant: 'v1',
    status: 'PUBLISHED',
    modules: [
      { id: 'mod-4-1', title: 'Mini-grid Market Overview', lessons: 3 },
      { id: 'mod-4-2', title: 'Site Selection & Assessment', lessons: 5 },
      { id: 'mod-4-3', title: 'System Design', lessons: 6 },
      { id: 'mod-4-4', title: 'Financing Models', lessons: 4 },
      { id: 'mod-4-5', title: 'Installation & Commissioning', lessons: 5 },
      { id: 'mod-4-6', title: 'Operations & Maintenance', lessons: 4 }
    ]
  }
];
